import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
}

const KeyholeDashedCircleOutline = createIcon({
  displayName: 'KeyholeDashedCircleOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g id="Layer_2" data-name="Layer 2">
        <path d="M0,0H24V24H0Z" fill="none" />
        <path
          d="M17.925,5.237a8.98607,8.98607,0,0,1,2.902,5.013"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M6.075,18.763A8.98607,8.98607,0,0,1,3.173,13.75"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M14.896,20.515a8.8887,8.8887,0,0,1-5.792,0"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M14.896,3.485a8.8887,8.8887,0,0,0-5.792,0"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M17.925,18.763a8.98607,8.98607,0,0,0,2.902-5.013"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M3.173,10.25A8.97793,8.97793,0,0,1,6.075,5.237"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M13.57428,12.5a2.75,2.75,0,1,0-3.14856,0"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M10.42572,12.5l-.73414,2.74131a1,1,0,0,0,.966,1.25869h2.68593a1,1,0,0,0,.96587-1.259L13.57428,12.5"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </>
  ),
})

const KeyholeDashedCircleFilled = createIcon({
  displayName: 'KeyholeDashedCircleFilled',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g id="Layer_2" data-name="Layer 2">
        <path d="M0,0H24V24H0Z" fill="none" />
        <path
          d="M17.925,5.237a8.98607,8.98607,0,0,1,2.902,5.013"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M6.075,18.763A8.98607,8.98607,0,0,1,3.173,13.75"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M14.896,20.515a8.8887,8.8887,0,0,1-5.792,0"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M14.896,3.485a8.8887,8.8887,0,0,0-5.792,0"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M17.925,18.763a8.98607,8.98607,0,0,0,2.902-5.013"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M3.173,10.25A8.97793,8.97793,0,0,1,6.075,5.237"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M13.57428,12.5a2.75,2.75,0,1,0-3.14856,0"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M10.42572,12.5l-.73414,2.74131a1,1,0,0,0,.966,1.25869h2.68593a1,1,0,0,0,.96587-1.259L13.57428,12.5"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </>
  ),
})

const KeyholeDashedCircle: FC<CustomIconProps> = (props) => {
  if (props.variant === 'filled') {
    return <CustomIcon as={KeyholeDashedCircleFilled} {...props} />
  }
  return <CustomIcon as={KeyholeDashedCircleOutline} {...props} />
}

export default memo(KeyholeDashedCircle)
